// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FeaturedProducts: React.FC = () => {
    return (
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 55 62" enableBackground="new 0 0 55 62" xmlSpace="preserve">
<path id="tab" fillRule="evenodd" clipRule="evenodd" fill="#FDBB1F" d="M40.29,0H14.71H0v47.25c0,8.12,6.59,14.71,14.71,14.71
	h25.57c8.12,0,14.71-6.59,14.71-14.71V0H40.29z"/>
<path id="shadow" fill="#A35D0F" d="M43.04,24.03c-0.13-0.41-0.51-0.68-0.94-0.68l-5.95,0L28.23,13.1c-0.14-0.4-0.51-0.67-0.94-0.67
	c-0.42,0-0.8,0.27-0.94,0.67L23.4,23.35l-10.92,0c-0.43,0-0.81,0.28-0.94,0.68c-0.13,0.41,0.02,0.85,0.36,1.1l8.16,9.37l-2.64,7.48
	c-0.14,0.41,0.09,0.69,0.33,0.85C18,43,34.71,61.12,35.48,61.96h4.81c8.12,0,14.71-6.58,14.71-14.71v-7.81
	C55,39.45,43.11,24.26,43.04,24.03z"/>
<defs>
	<filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="11.49" y="12.43" width="31.59" height="30.57">
		<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
	</filter>
</defs>
<path id="star_1_" fillRule="evenodd" clipRule="evenodd" fill="#FEFEFE" d="M17.76,42.84
	c-0.25-0.16-0.47-0.44-0.33-0.85l3.65-10.32l-9.17-6.53c-0.35-0.25-0.49-0.7-0.36-1.1c0.13-0.41,0.51-0.68,0.94-0.68l10.92,0
	l2.95-10.25c0.13-0.4,0.51-0.67,0.94-0.67c0.43,0,0.8,0.27,0.94,0.67l3.05,10.25l10.82,0c0.43,0,0.81,0.28,0.94,0.68
	c0.13,0.41-0.02,0.85-0.36,1.1l-8.89,6.51l3.61,10.26c0.14,0.41,0.13,0.65-0.2,0.93c-0.33,0.28-0.79,0.13-0.96,0.01l-8.94-6.44
	l-8.53,6.34C18.59,42.88,18.01,43,17.76,42.84"/>
</svg>  
    );
};


export default React.memo(FeaturedProducts);


